import React, { useCallback, useEffect, useState } from "react";
import Select, { SingleValue, ActionMeta } from "react-select";
import { useNavigate, useLocation  } from "react-router-dom";
import { useSelector } from "react-redux";

import axios from "axios";

import { useAppDispatch } from "../../store";
import { RootState } from "../../reducer/index";
import { LoadFarm, LoadDiaryList } from "../../reduxaction/post";
import { placestype, DiaryClasstype, NoticeListType } from "../../reducer/postpayloadtypes/index";
import { useInView } from "react-intersection-observer";
import Loader from "../../components/Loader";
import postSlice from "../../reducer/post";
import { SelectOptionType } from "../../FrontType/index";
import userSlice from "../../reducer/user";
import dayjs from "dayjs";
import InsectName from "../MainFolder/PostDiary/component/InsectName";

import styled from "styled-components/macro";
import * as styles from "../../styles/MainPage";

dayjs.locale("ko");

const Scrolltobutton = styled.div`
  position: fixed;
  bottom: 170px;
  right: 60px;
  text-align: center;
  width: 100px;
  border: 1px solid #73972c;
  padding: 8px 10px;
  border-radius: 7px;
  /* background-color: #4ca0f4; */
  background-color: #73972c;
  color: white;
  cursor: pointer;
`;

const Notice = styled.div`
  /* background-color: lavender; */
  display: flex;
  .numbers {
    margin-top: 15px;
    margin-right: 10px;
    position: absolute;
    right: 0;
    top: 0;
    width: 25px;
    height: 20px;
    font-size: 13px;
    background-color: #e60023;
    border-radius: 10px;
    color: black;
    text-align: center;
    color: white;
  }
`;
const MainPage = () => {
  let [arrow, setarrow] = useState(true);
  const dispatch = useAppDispatch();

  const { me, Routerpath } = useSelector((state: RootState) => state.user);
  const [page, setPage] = useState<number>(1);
  const [serchpage, setSerchpage] = useState<number>(1);
  const { Farms, Diarylist, Targetfarms, DiarylistLoading, TargetfarmsDone } = useSelector((state: RootState) => state.post);



  // data State
  const [insects, setInsects] = useState<placestype[]>([]);
  const [diarytype, setDiarytype] = useState<DiaryClasstype[]>([]);

  // select box List options
  const [insectBox, setInsectBox] = useState<SelectOptionType[]>([]);
  const [diarytypeBox, setDiarytypeBox] = useState<SelectOptionType[]>([]);

  // user select State options(Search)
  const emptyOption = { value: "WHOLE", label: "전체" };
  const [selectedInsect, setSelectedInsect] = useState<SelectOptionType>(emptyOption);
  const [selectedDiaryType, setSelectedDiaryType] = useState<SelectOptionType | null>();
  const location = useLocation();

  // const [diarytypes, setdiarytypes] = useState<any>(emptyOption);

  const [startdate, setStartdate] = useState<string>("");
  const [chkdate, setChkdate] = useState<any>();

  const [enddate, setEnddate] = useState<string>("");
	let [boxName, setBoxName] = useState<string>(""); 

  const [serchactive, setSerchactive] = useState<boolean>(false);
  const [notiList, setNotiList] = useState<NoticeListType[]>([]);

  const navigate = useNavigate();

  const [placeFarm, setPlaceFarm] = useState<SelectOptionType[]>([]);
  const [category, setCategory] = useState<SelectOptionType>({
    label: Targetfarms?.name ?? "",
    value: Targetfarms?.placeId.toString() ?? "",
	});
	
	let [viewBox, setViewBox] = useState<boolean>(false);
	let [subBoxId, setSubBoxId] = useState(0); // 수정할 상
	let [viewDateKey, setViewDateKey] = useState<string>("");
	let [productCode, setProductCode] = useState<string>("");
	
  const categoryHandleChange = async (event: any) => {
    // category 변경 event
    const gettargetFarm = Farms.find((v) => v.placeId === Number(event.value));
    if (gettargetFarm) {
      await localStorage.setItem("targetfarm", gettargetFarm.placeId.toString());
      await localStorage.setItem("targetfarmInfo", JSON.stringify(gettargetFarm));

      setCategory({ label: gettargetFarm?.name, value: event.value });
      dispatch(postSlice.actions.targetFarm(gettargetFarm));
			dispatch(postSlice.actions.refreshDiaryList());

      dispatch(
        LoadDiaryList({
          page: 0,
          size: 10000,
          productCode: selectedInsect.value,
          diaryType: selectedDiaryType?.value ?? '',
          startDate: startdate,
          endDate: enddate,
					boxName: boxName,
					farmId: localStorage.getItem("targetfarm")
					,test:"3"
        })
      );
    }
	};
	
  useEffect(() => {
    const getAsyncTargetFarm = async () => {
      const savedtargetfarmId = await localStorage.getItem("targetfarm");

      if (savedtargetfarmId) {
        const TargetFa = Farms.find(
          (v) => v.placeId === Number(savedtargetfarmId)
        );

        // setCategory(
        //   TargetFa
        //     ? { label: TargetFa.name, value: TargetFa.placeId.toString() }
        //     : { label: Farms?.[0]?.name, value: Farms?.[0]?.placeId.toString() }
        // );

        // !수정 시작
        if (!TargetFa) {
          setCategory({ label: Farms?.[0]?.name, value: Farms?.[0]?.placeId.toString() });
          // 로컬스토리지에 선택한 농장 정보 전체 저장
          localStorage.setItem("targetfarm", Farms?.[0]?.placeId.toString());
          localStorage.setItem("targetfarmInfo", JSON.stringify(Farms?.[0]));
        } else {
          setCategory({ label: TargetFa.name, value: TargetFa.placeId.toString() });
        }

        // !수정 종료
      } else {
        setCategory({ label: Farms?.[0]?.name, value: Farms?.[0]?.placeId.toString() });
        // 로컬스토리지에 선택한 농장 정보 전체 저장
        localStorage.setItem("targetfarm", Farms?.[0]?.placeId.toString());
        localStorage.setItem("targetfarmInfo", JSON.stringify(Farms?.[0]));
      }
    };

		if (Boolean(Farms.length)) getAsyncTargetFarm();
		
    const getPlace = async () => {
      if (Farms.length >= 1) {
        const placeconvert = Farms.map((farm) => {
          return {
            label: farm.name,
            value: String(farm.placeId),
          };
        });
        setPlaceFarm(placeconvert);
      }
    };

    getPlace();
  }, [Farms]);

  // 초기 로딩 시 농장 정보 불러오기
  useEffect(() => {
    if (me) dispatch(LoadFarm());
  }, [me]);

  useEffect(() => {
    dispatch(postSlice.actions.refreshDiaryList());

    if (!serchactive && Targetfarms) {
//      dispatch(LoadDiaryList({ page: 0, size: 10, farmId: localStorage.getItem("targetfarm") }));
    }
  }, [dispatch, serchactive]);

  useEffect(() => {
		dispatch(userSlice.actions.Routerpath("/MainPage"));
		
    const getNotiList = async () => {
      try {
        const response = await axios.get(`ifactory/api/notice`);

        setNotiList(response.data);
      } catch (error) {
        console.error(error);
      }
    };
		getNotiList();
  }, []);

	const Navifunc = useCallback((type: string,  isArrow: string, id1: string, id2: string, id3: string, id4: string, id5: string ) => {

    if (type === "DiaryPage") {
			dispatch(userSlice.actions.Routerpath("/DiaryPage"));
			navigate("/DiaryPage", {
				state: {
					isArrow: isArrow,
					id1: id1,
					id2: id2,
					id3: id3,
					id4: id4,
					id5: id5
				}
			});
    } else if (type === "EnvirdataPage") {
      dispatch(userSlice.actions.Routerpath("/EnvirdataPage"));
      navigate("/EnvirdataPage");
    } else if (type === "WholedataPage") {
      dispatch(userSlice.actions.Routerpath("/WholedataPage"));
      navigate("/WholedataPage");
    } else if (type === "AdvicePage") {
      dispatch(userSlice.actions.Routerpath("/AdvicePage"));
      navigate("/AdvicePage");
    } else if (type === "PostSelectInsect") {
      dispatch(userSlice.actions.Routerpath("/PostSelectInsect"));
      navigate("/PostSelectInsect");
    } else if (type === "PostDiaryPage") {
      dispatch(userSlice.actions.Routerpath("/PostDiaryPage"));
      navigate("/PostDiaryPage");
    } else if (type === "PostDetail") {
      dispatch(userSlice.actions.Routerpath("/PostDetail"));
      navigate("/PostDetail");
    } else if (type === "Test") {
      dispatch(userSlice.actions.Routerpath("/Test"));
      navigate("/Test");
    } else if (type === "SelectSetting") {
      dispatch(userSlice.actions.Routerpath("/SelectSetting"));
      navigate("/SelectSetting");
    } else if (type === "Setting") {
      dispatch(userSlice.actions.Routerpath("/Setting"));
      navigate("/Setting");
    } else if (type === "NoticeList") {
      dispatch(userSlice.actions.Routerpath("/NoticeList"));
      navigate("/NoticeList");
    } else if (type === "ExcelData") {
      dispatch(userSlice.actions.Routerpath("/ExcelData"));
      navigate("/ExcelData");
    } else if (type === "MonitoringPage") {
      dispatch(userSlice.actions.Routerpath("/MonitoringPage"));
      navigate("/MonitoringPage");
    }
  }, []);

  const placesname = (places: placestype[]) => {
    let compo: any = [];

    for (let i = 1; i <= places.length; i++) {
      compo = [...compo, <div>{places[i]?.name}</div>];
    }
    return compo;
  };
  // ------------- 인피니트 스크롤링 코드

  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0.1,
	});
	



	useEffect(() => {
    if (inView && !DiarylistLoading && !serchactive) {
      setPage(page + 1);
      dispatch(LoadDiaryList({ page: page, size: 10000, farmId: localStorage.getItem("targetfarm"),test:"1" }));
    } else if (inView && !DiarylistLoading && serchactive) {
			setSerchpage(serchpage + 1);
			
      dispatch(
        LoadDiaryList({
          page: serchpage,
          size: 10000,
          productCode: selectedInsect.value,
          diaryType: selectedDiaryType?.value ?? '',
          startDate: startdate,
          endDate: enddate,
					boxName: boxName,
					farmId: localStorage.getItem("targetfarm"),
					test:"2",
        })
      );
    }
  }, [inView, page, serchpage, serchactive, me]);

  const Scrollto = () => {
    console.log("Scrollto");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // useEffect(() => {
  //   if (Targetfarms) {
  //     const insects = Targetfarms
  //       ? Targetfarms.children.map((place) => {
  //           return {
  //             label: place.productCodeInfo.name,
  //             value: place.productCodeInfo.code,
  //           };
  //         })
  //       : [];

  //     // console.log("insects:", insects);
  //     const result: InsectType[] = insects.filter(
  //       (v: any, i: number) =>
  //         insects.findIndex((x) => x.label === v.label) === i
  //     );

  //     result.unshift({ label: "전체", value: "whole" });

  //     setInsects(result);
  //   }
  // }, [Targetfarms]);

  //ANCHOR - (selectbox) 농장 변경 > 곤충 선택 박스 리스트
  useEffect(() => {
    if (Targetfarms) {

      const getInsectList = async () => {
        try {
          const response = await axios.get(`ifactory/api/productcode`);
          setInsects(response.data);

          // 중복제거
          const uniqueData = response.data.filter((v: placestype, i: number, a: placestype[]) =>
            a.findIndex(t => (t.productCode === v.productCode)) === i
          );

          const insectSelectBoxList: SelectOptionType[] = [
            emptyOption,
            ...uniqueData.map((insect: placestype) => {
              return { label: InsectName(insect.productCode), value: insect.productCode };
            })
          ];

          setInsectBox(insectSelectBoxList);
        } catch (error: any) {
          console.error("error:", error);
        }
      };

      getInsectList();
    }
	}, [Targetfarms]);
	
	useEffect(() => {

		if (Diarylist.length > 0)
		{
			const grouped: any = [];

			Diarylist.map((list , idx) =>
			{
				const dateKey = dayjs(list.tagStdDate).format("YYYY년 MM월 DD일"); 

				if (!grouped[dateKey]) {
					grouped[dateKey] = list.diaryId;
				}
			});
			
			setChkdate(grouped);
		}
}, [Diarylist]);

  //ANCHOR : (selectbox) 곤충 선택 > 작업 선택 리스트
	useEffect(() => {
    const loadTargetDiary = async () => {
      try {
        const response = await axios.get(`/ifactory/api/diarycode/class?productCode=${selectedInsect.value}`);
        // 전체 상태 저장
        setDiarytype(response.data);

        // 중복제거
        const uniqueData = response.data.filter((v: DiaryClasstype, i: number, a: DiaryClasstype[]) =>
          a.findIndex(t => (t.diaryType === v.diaryType)) === i
        );

        // Diary Select options 세팅
        const diarySelectBoxList: SelectOptionType[] = [
          ...uniqueData.map((diary: DiaryClasstype) => {
            return { label: diary.name, value: diary.diaryType };
          })
        ];

				setDiarytypeBox(diarySelectBoxList);
				if(selectedDiaryType === undefined) setSelectedDiaryType(diarySelectBoxList[0]);
      } catch (error: any) {
        console.log("error:", error);
      }
    }
    loadTargetDiary();
  }, [selectedInsect]);

  const onChangtimefunc = (e: any) => {
    if (e.target.name === "start") {
      setStartdate(e.target.value);
    } else if (e.target.name === "end") {
      setEnddate(e.target.value);
    }
	};
	
  const onChangBoxfunc = (e: any) => {
      setBoxName(e.target.value);
	};
	
	const searchfunc = useCallback(() => {
		dispatch(postSlice.actions.refreshDiaryList());
		setPage(1);
		setSerchpage(1);
    dispatch(
      // placeId 뺀거
      LoadDiaryList({
        page: 0,
        size: 10000,
        productCode: selectedInsect.value,
        diaryType: selectedDiaryType?.value ?? '',
        startDate: startdate,
        endDate: enddate,
        boxName: boxName,
        farmId: localStorage.getItem("targetfarm"),test:"4"
      })
    );

		setProductCode("");
		setSubBoxId(0);
		setViewBox(false);
		setViewDateKey("");
    setSerchactive(true);
  }, [Targetfarms, selectedInsect, selectedDiaryType, startdate, enddate, serchactive,boxName ]);

	
	useEffect(() => {
		let isArrow = "";
		let id1 = "";
		let id2 = "";
		let id3 = "";
		let id4 = "";
		let id5 = ""; 		
		
		if (location.search || (location.state != null && location.state.isArrow )) {
			setSerchactive(true);

			isArrow = location.search ? location.search.split("&")[0].split("=")[1]: location.state.isArrow;
			id1 = location.search ? location.search.split("&")[1].split("=")[1]: location.state.id1;
			id2 = location.search ? location.search.split("&")[2].split("=")[1]: location.state.id2;
			id3 = location.search ? location.search.split("&")[3].split("=")[1]: location.state.id3;
			id4 = location.search ? location.search.split("&")[4].split("=")[1]: location.state.id4;
			id5 = location.search ? location.search.split("&")[5].split("=")[1]: location.state.id5;


			if (isArrow !== "") setarrow(isArrow === "Y" ? true : false);

			if (id1 !== "") {
				insectBox.map((item: any, idx: number) => {
					if (id1 === item.value) setSelectedInsect({ label: item.label, value: item.value });
				});
			}
			else
			{
				setSelectedInsect(emptyOption);				
			}

			if (id2 !== "") {
				diarytypeBox.map((item: any, idx: number) => {
					if (id2 === item.value) setSelectedDiaryType({ label: item.label, value: item.value });
				});
			}
			
			if (id3 !== "")  setStartdate(id3);
			if (id4 !== "") setEnddate(id4);
			if (id5 !== "") setBoxName(id5);
		}
		else
		{
			setSerchactive(false);

			setSelectedInsect(emptyOption);
			setDiarytypeBox([]);
			setStartdate(dayjs().subtract(1, "month").format("YYYY-MM-DD"));
			setEnddate(dayjs().format("YYYY-MM-DD"));

			id1 = selectedInsect.value;
			id2 = selectedDiaryType?.value ?? '';
			id3 = startdate;
			id4 = enddate;
			id5 = boxName;
		}

		setInsectBox([emptyOption]);
    // setSelectedDiaryType('');

		dispatch(postSlice.actions.refreshDiaryList());

		if (Targetfarms) {
      dispatch(LoadDiaryList({
        page: 0,
        size: 10000,
        productCode: id1,
        diaryType: id2,
        startDate: id3,
        endDate: id4,
        boxName: id5,
        farmId: localStorage.getItem("targetfarm"),test:"5"
      }))
		}
		
  }, [Targetfarms]);

  const notiListnumber = notiList?.filter((v) => v.memberCheckYn === "N");

	const viewBoxClick = (diaryId: number, chkClickYn: boolean ,chkDateKey : string, tmpProductCode?:string) => {
		if (diaryId === subBoxId && chkDateKey === viewDateKey)
		{
			setViewBox(!chkClickYn);
			setViewDateKey(chkDateKey);
		}
		else
		{
			setSubBoxId(diaryId);
			setViewBox(true);
			setViewDateKey(chkDateKey);

			const tmpProductCode1 = Diarylist.find((list) => list.diaryId === subBoxId)?.diaryClass?.productCode;
			setProductCode(tmpProductCode === undefined? tmpProductCode1 === undefined?"":tmpProductCode1 : tmpProductCode);
		}
	};
	
	const godetailfunc = (diaryId: number) => {
		dispatch(userSlice.actions.Routerpath("/DiaryDetail"));

		navigate("/DiaryDetail?id=" + diaryId.toString(), {
			state: {
				id: diaryId,
				isArrow : arrow?'Y':'N',
				id1: selectedInsect.value,
				id2: selectedDiaryType?.value??'',
				id3: startdate.toString(),
				id4: enddate.toString(),
				id5: boxName.toString(),
				backUrl: "MainPage",
			}
		});
	};
	
  return (
		<styles.Container>
			<styles.MenuBox>
				<styles.MenuTop>
					<div className="logostring">
						I.FACTORY
						<span className="logospan"> FARM</span>
					</div>
					
					<div className="main-icon">
						{/* 수정 시작 */}
						{placeFarm.length >= 2 ? (
							<div style={{ display: "flex", alignItems: "center", /* background: "lavender",*/ marginRight: 20, }}>
								
								<div style={{ fontSize: 15, fontWeight: "bold", marginRight: 10, /* width: 100,*/ }} >
									농장선택:
								</div>
								<Select
									value={category}
									onChange={categoryHandleChange}
									options={placeFarm}
									menuPortalTarget={document.body}
									styles={{
										control: (baseStyles: any, state) => ({
											...baseStyles,
											borderColor: state.isFocused
												? "rgb(118, 118, 118)"
												: "rgb(133, 133, 133)",
											width: "100%",
											fontSize: 15
										}),
									}}
								/>
							</div>
						) : (
								<div style={{ /* display: "none",*/ alignItems: "center", /* background: "lavender",*/ marginRight: 20, }} >
									<div style={{ fontSize: 20, fontWeight: "bold", marginRight: 10, /* width: 200,*/ }} >
										{placeFarm[0]?.label}
									</div>
									<Select
										value={category}
										onChange={categoryHandleChange}
										options={placeFarm}
										menuPortalTarget={document.body}
										styles={{
											control: (baseStyles: any, state) => ({
												...baseStyles,
												borderColor: state.isFocused
													? "rgb(118, 118, 118)"
													: "rgb(133, 133, 133)",
												width: "100%",
												display: "none",
											}),
										}}
								/>
							</div>
						)}
						
						{/* 수정 완료 */}
						<img src="/img/profile.svg" onClick={() => Navifunc("Setting", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)} />
						
						<Notice>
							{notiListnumber.length >= 1 && (
								<div className="numbers">{notiListnumber?.length}</div>
							)}
							<img
								src="/img/alarm.svg"
								onClick={() => Navifunc("NoticeList", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)}
							/>
						</Notice>
					</div>
				</styles.MenuTop>
				<styles.MenuBot>
					<div className="menu-item" onClick={() => Navifunc("SelectSetting", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)}>
						<img src="/img/defualtSetting.svg" />
						<p className="menu-item-title">기본설정</p>
					</div>
					<div className="menu-item" onClick={() => Navifunc("MonitoringPage", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)}>
						<img src="/img/menu_06.svg" />
						<p className="menu-item-title">모니터링</p>
					</div>
					<div className="menu-item" onClick={() =>
						Navifunc("DiaryPage", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)
					}>
						<img src="/img/menu_01.svg" />
						<p className="menu-item-title">사육일지</p>
					</div>
					<div className="menu-item" onClick={() => Navifunc("EnvirdataPage", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)}>
						<img src="/img/menu_05.svg" />
						<p className="menu-item-title">환경데이터</p>
					</div>
					<div className="menu-item" onClick={() => Navifunc("WholedataPage", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)}>
						<img src="/img/menu_03.svg" />
						<p className="menu-item-title">종합데이터</p>
					</div>
					<div className="menu-item" onClick={() => Navifunc("ExcelData", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)}>
						<img src="/img/menu_02_1.svg" />
						<p className="menu-item-title">환경 종합데이터</p>
					</div>
					<div className="menu-item" onClick={() => Navifunc("AdvicePage", (arrow ? 'Y' : 'N'), selectedInsect.value, (selectedDiaryType?.value ?? ''), startdate.toString(), enddate.toString(), boxName)}>
						<img src="/img/menu_04.svg" />
						<p className="menu-item-title">상담</p>
					</div>
				</styles.MenuBot>
			</styles.MenuBox>
			<styles.DiaryBox>
				{Diarylist === null ? (
					<styles.DiaryNoList>
						<p>일지내역이 없습니다.</p>
						<p>
							<img src="/img/write3.png" />
							버튼을 눌러 일지를 작성해주세요.
						</p>
					</styles.DiaryNoList>
				) : (
						<>
							<styles.DiarySelectBox>
								<styles.DiarySelectArrow>
									<p>상세검색</p>
									<p
										className={
											arrow === false
												? "diary-select-arrow-btn"
												: "diary-select-arrow-btn-rotate"
										}
										onClick={() => {
											setarrow(!arrow);
										}}
									>
										▲
									</p>
								</styles.DiarySelectArrow>
								<styles.DiarySelect className={arrow === false ? "show" : "hide"}>
									<styles.DiarySelectOn>
										<div className="diary-select-item">
											<p>곤충명</p>
											<Select
												value={selectedInsect}
												className="select"
												defaultValue={emptyOption}
												onChange={(selectedOption: SingleValue<SelectOptionType>, actionMeta: ActionMeta<SelectOptionType>) => {
													selectedOption ? setSelectedInsect(selectedOption) : setSelectedInsect(emptyOption);
												}}
												options={insectBox}
												menuPortalTarget={document.body}
												placeholder="검색 조건을 선택하세요"
												styles={{
													control: (baseStyles: any, state) => ({
														...baseStyles,
														borderColor: state.isFocused
															? "rgb(118, 118, 118)"
															: "rgb(133, 133, 133)",
														width: "100%",
														":active": {
															borderColor: state.isFocused ? "black" : "black",
														},
													}),
												}}
											/>
										</div>
										
										<div className="diary-select-item">
											<p>작업선택</p>
											
											<Select
												// defaultValue={  }
												value={selectedDiaryType}
												onChange={(selectedOption: SingleValue<SelectOptionType>, actionMeta: ActionMeta<SelectOptionType>) => {
													selectedOption ? setSelectedDiaryType(selectedOption) : setSelectedDiaryType(emptyOption);
												}}
												options={diarytypeBox}
												menuPortalTarget={document.body}
												placeholder="검색 조건을 선택하세요"
												styles={{
													control: (baseStyles: any, state) => ({
														...baseStyles,
														borderColor: state.isFocused
															? "rgb(118, 118, 118)"
															: "rgb(133, 133, 133)",
														width: "100%",
													}),
												}}
											/>
										</div>
										<div className="diary-select-item ">
											<p>기간선택</p>
											<div className="diary-date-box">
												<input
													type="date"
													name="start"
													id="start"
													value={startdate}
													onChange={(e) => onChangtimefunc(e)}
												/>
												<p>~</p>
												<input
													type="date"
													name="end"
													id="end"
													value={enddate}
													onChange={(e) => onChangtimefunc(e)}
												/>
											</div>
										</div>
										
										<div className="diary-select-item ">
											<p>상자명</p>
											<input type="text"
												placeholder="상자 이름 검색"
												name="boxName"
												style={{ width: "100%" }}
												value={boxName}
												onChange={(e) => onChangBoxfunc(e)}
											/>
										</div>
										<div className="diary-select-btn">
											<div className="diary-select-submit" onClick={searchfunc}>
												검색
											</div>
										</div>
									</styles.DiarySelectOn>
								</styles.DiarySelect>
							</styles.DiarySelectBox>
							{Diarylist.map((mlist, midx) => {
								const dateKey = dayjs(mlist.tagStdDate).format("YYYY년 MM월 DD일");
								if (chkdate && chkdate[dateKey] === mlist.diaryId)
								{
									let objectArray = [];
									objectArray = Array.from(new Set(Diarylist.filter(list => dayjs(list.tagStdDate).format("YYYY년 MM월 DD일") === dateKey).map((list) => list.manageBoxId)));
									
									return (
										<>
											<div
												className="diary-item"
												key={mlist.diaryId + midx}
												style={{ cursor: "unset" }}
												ref={ref}
											>
												<div className="diary-item-status">
													<div className="diary-item-status-top">
														<p className="diary-item-user" style={{ fontSize: "1.5em", fontWeight: "bold" }}>
															{dateKey}
														</p>
													</div>
													<div className="diary-item-status-bot" style={{ marginTop: 10 }}>
													</div>
													{objectArray.map((assetInfo, i) => {
														let instarcolor = "";
														
														switch (Diarylist.find((v) => v.manageBoxId === assetInfo)?.instar) {
															case "EGG":
																instarcolor = "#feca0a";
																break;
															case "IMAGO":
																instarcolor = "#b96730";
																break;
															case "PUPA":
																instarcolor = "#afaad3";
																break;
															case "LARVA":
																instarcolor = "#8bc63e";
																break;
															default:
																instarcolor = "lightgray";
														}
														
														return (
															<>
																<div className="diary-item-content-bot" style={{ display: "inline-flex", cursor: "pointer" }}
																	onClick={() => { viewBoxClick(assetInfo, viewBox, dateKey ,  Diarylist.find((v) => v.manageBoxId === assetInfo)?.diaryClass.productCode) }}
																>
																	<p className="diary-item-content-box-list" style={{ background: "#2a3a4b", color: "white" }}>
																		{Diarylist.find((v) => v.manageBoxId === assetInfo)?.boxName}
																	</p>
																</div>
															</>
														)
													})}
												</div>						
												
												{viewBox && dateKey === viewDateKey && Diarylist.filter(list => dayjs(list.tagStdDate).format("YYYY년 MM월 DD일") === dateKey && list.manageBoxId === subBoxId).map((list) => {
													return (
														<div className="diary-item" ref={ref} onClick={() => { godetailfunc(list.diaryId) }}>
															<div className="diary-item-status">
																<div className="diary-item-status-top">
																	<p className="diary-item-user">																		
																		작성자:<span> {list.worker}</span>
																	</p>
																	<p className="diary-item-date">작성 날짜: {dayjs(list?.tagStdDate).format("YYYY년 MM월 DD일 dddd HH시 mm분")}</p>
																</div>
																<div className="diary-item-status-bot" style={{ marginTop: 10 }} >
																	<p className="diary-item-insect-name">
																		{InsectName(list.diaryClass.productCode)}
																	</p>
																	<p className="diary-item-conduct">
																		<span>{list?.diaryClass?.name}</span>
																	</p>
																</div>
															</div>
															<div className="diary-item-memo">
																<p>
																	{list.note?.length > 40
																		? `${list?.note.slice(0, 40)}...`
																		: list?.note}
																</p>
															</div>
														</div>
													)
												})}
											</div>
										</>
										
									);
								}
							})}
							
					</>
				)}
			</styles.DiaryBox>
			{DiarylistLoading && <Loader />}
			<div
				className="diary-write-btn"
				onClick={() => navigate("/PostSelectInsect", {
					state: {
						isArrow: arrow ? 'Y' : 'N',
						id1: selectedInsect.value,
						id2: selectedDiaryType?.value ?? '',
						id3: startdate.toString(),
						id4: enddate.toString(),
						id5: boxName
					}
				})}
			>
				<img src="/img/write3.png" />
			</div>
			
			<Scrolltobutton onClick={Scrollto}>Top</Scrolltobutton>
		</styles.Container >
	);
};

export default MainPage;